"use client";
import React, { useState, useEffect } from "react";
import "./float.css"
import { Link } from "react-scroll"

  
function FloatingNavbar({navItems, show2, scrollToElement}) {
   

    


  return (
    <div className={`${show2 ? "ScrollingDown" : "floats"}`} >
        
    <h2  className="navlink" onClick={() => scrollToElement("about")} >
        About
    </h2>
    <h2  className="navlink" onClick={() => scrollToElement("testimonials")} >
   Testimonials
</h2>
<h2  className="navlink" onClick={() => scrollToElement("projects")} >
       Projects    </h2>
    <h2  className="navlink" onClick={() => scrollToElement("contact")} >
    Contact
</h2>


          
   </div>
  )
}

export default FloatingNavbar